<template>
    <div>
      <div class="category-top-bar" ref="optionsTopBar">
        <div class="top-bar">
          <p>
            <a class="btn btn-orange btn-icon back" @click="goBack">
              <i class="ti-arrow-left"></i>
              {{ $t('general.back') }}
            </a>
          </p>
          <p class="d-inline-flex">
              <button type="submit" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;" @click="saveBonTransfer()" :title="$t('general.save')">
                <img src="/static/img/icons/save.png">
                {{$t('general.save')}}
              </button>
          </p>
        </div>
      </div>
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <p>{{ $t('gestiune.notaTransfer') }}</p>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ $t('gestiune.fromLocation') }}</label>
                  <select class="form-control" v-model="selectedLocationId" :disabled="isEdit">
                    <option value="" disabled>Selectează locația</option>
                    <optgroup
                      v-for="group in groupedLocations"
                      :key="group.vat"
                      :label="`VAT: ${group.vat}`"
                    >
                      <option
                        v-for="loc in group.locations"
                        :key="loc.true_id"
                        :value="loc.true_id"
                      >
                        {{ loc.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="gestiune">{{ $t('gestiune.fromGestiune') }}*</label>
                  <select v-model="bonTransfer.fromGestiune" class="form-control" :disabled="isEdit">
                    <option disabled value="">Selectează gestiunea</option>
                    <option
                      v-for="option in filteredGestiuni"
                      :key="option.id"
                      :value="option.id"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ $t('gestiune.toLocation') }}</label>
                  <select class="form-control" v-model="selectedToLocationId" :disabled="isEdit">
                    <option value="" disabled>Selectează locația</option>
                    <optgroup
                      v-for="group in groupedLocations"
                      :key="group.vat"
                      :label="`VAT: ${group.vat}`"
                    >
                      <option
                        v-for="loc in group.locations"
                        :key="loc.true_id"
                        :value="loc.true_id"
                        :disabled="isDisabledToLocation(loc)"
                      >
                        {{ loc.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="gestiune">{{ $t('gestiune.toGestiune') }}*</label>
                  <select v-model="bonTransfer.toGestiune" class="form-control" :disabled="isEdit">
                    <!-- Placeholder -->
                    <option disabled value="">Selectează gestiunea</option>

                    <!-- Opțiuni filtrate -->
                    <option
                      v-for="option in filteredToGestiuni"
                      :key="option.id"
                      :value="option.id"
                      :disabled="option.disabled"
                    >
                      {{ option.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="serie">{{ $t('invoice.series') }}*</label>
                   <select v-model="bonTransfer.serie" class="form-control" :disabled="isEdit" @change="handleSerieChange">
                    <!-- Placeholder -->
                    <option disabled value="">Selectează seria</option>

                    <option v-if="isEdit" :value="bonTransfer.serie">
                      {{ bonTransfer.serie }}
                    </option>

                    <!-- Opțiuni existente -->
                    <option
                      v-for="serie in seriesOptionsWithAdd"
                      :key="serie.value"
                      :value="serie.value"
                    >
                      {{ serie.label }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{$t('gestiune.data')}}*</label>
                  <input type="datetime-local" name="date" v-model="bonTransfer.date" :max="today" :disabled="!selectedLocationId" @change="checkValidatedAfter(bonTransfer.date)" class="form-control">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card mar-to-15">
        <div class="card-content">
          <div class="col-md-12">
            <p>{{$t('gestiune.addProductInBonTransfer')}}</p>
            <hr class="sm">
          </div>

          <el-table :data="tableData" style="width: 100%">
            <el-table-column :label="$t('gestiune.productName')" prop="productName">
              <template slot-scope="scope">
                {{ scope.row.productName }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.um')" prop="um">
              <template slot-scope="scope">
                {{ scope.row.um }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('gestiune.cantitate')" prop="cantitate">
              <template slot-scope="scope">
                {{ scope.row.cantitate }}
              </template>
            </el-table-column>

            <el-table-column :label="$t('general.actions')" width="100">
              <template slot-scope="scope">
                <el-dropdown trigger="click" placement="bottom-end">
                  <!-- Trigger: săgeată jos cu border violet -->
                  <span class="arrow-box">&#9662;</span>

                  <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                    <el-dropdown-item @click.native="editRow(scope.row)">
                      {{$t('general.edit')}}
                    </el-dropdown-item>
                    <el-dropdown-item @click.native="deleteRow(scope.row)">
                      {{$t('general.delete')}}
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>

          </el-table>
          <button class="btn add mar-rt-10 mar-bt-5 mar-to-15" :disabled="!selectedLocationId" @click.prevent="openAddProductModal" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/add.png">
            {{$t('gestiune.addProduct')}}
          </button>
        </div>
      </div>
      <div class="row" style="gap: 15px; display: flex;">
        <!-- <div class="card col-md-6 no-padding">
          <div class="card-content">
            <div class="modal-header">
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label for="genereazaAvizNIR">{{ $t('gestiune.generateAvizNIR') }}</label>
                <input
                  type="checkbox"
                  id="genereazaAvizNIR"
                  v-model="genereazaAvizNIR"
                />
              </div>

              <div v-if="genereazaAvizNIR">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="avizSelect">{{ $t('gestiune.avizGestiuneaPredatoare') }}</label>
                       <el-select v-model="selectedAviz" placeholder="Selectează Avizul">
                          <el-option
                            v-for="aviz in avizOptions"
                            :key="aviz.value"
                            :label="aviz.label"
                            :value="aviz.value"
                          />
                        </el-select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="dataAviz">{{ $t('gestiune.dataAviz') }}</label>
                      <input
                        type="date"
                        id="dataAviz"
                        v-model="dataAviz"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="genereazaAvizNIR">
                <div class="row">
                  <div class="col-md-6">
                     <div class="form-group">
                        <label for="nirSelect">{{ $t('gestiune.nirGestiuneaPrimitoare') }}</label>
                        <el-select v-model="selectedNir" placeholder="Selectează NIR-ul">
                          <el-option
                            v-for="nir in nirOptions"
                            :key="nir.value"
                            :label="nir.label"
                            :value="nir.value"
                          />
                        </el-select>
                      </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="dataNIR">{{ $t('gestiune.dataNIR') }}</label>
                      <input
                        type="date"
                        id="dataNIR"
                        v-model="dataNIR"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="card col-md-6 no-padding">
          <div class="card-content">
            <div class="modal-header">
              <!-- <p>{{ $t('gestiune.bonTransfer') }}</p> -->
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="gestionar">{{ $t('gestiune.manager') }}</label>
                    <el-input v-model="bonTransfer.manager" placeholder="Introdu numele gestionarului" />
                  </div>

                  <div class="form-group">
                    <label for="primitor">{{ $t('gestiune.receiver') }}</label>
                    <el-input v-model="bonTransfer.receiver" placeholder="Introdu numele primitorului" />
                  </div>

                  <div class="form-group">
                    <label for="comandaProiect">{{ $t('gestiune.commandProject') }}</label>
                    <el-input v-model="bonTransfer.commandProject" placeholder="Adaugă o comandă/proiect" />
                  </div>

                  <div class="form-group">
                    <label for="notaInterna">{{ $t('gestiune.internalNote') }}</label>
                    <el-input v-model="bonTransfer.internalNote" placeholder="Adaugă o notă internă" type="textarea" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <vmodal name="addProductModal" height="auto" width="600" class="addProductModal">
        <div class="card">
          <div class="card-content">
            <div class="modal-header">
              <p>{{$t('gestiune.addProduct')}}</p>
            </div>
            <div class="modal-body">
              <div class="row">

                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{$t('gestiune.productName')}}*</label>
                    <v-select
                      v-model="item.productObject"
                      :options="searchResults"
                      label="label"
                      :reduce="option => option.value"
                      placeholder="Caută un produs..."
                      :filterable="false"
                      @search="fetchProducts"
                      @input="handleProductSelect"
                    >
                      <template #no-options>
                        <span v-if="!loading">Niciun produs găsit</span>
                      </template>
                    </v-select>

                    <div v-if="loading" class="v-select-loader"></div>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('gestiune.um')}}*</label>
                    <select v-model="item.um" class="form-control" disabled>
                      <option :value="item.um">{{item.um}}</option>
                    </select>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{$t('gestiune.cantitate')}}*</label>
                    <input type="number" :placeholder="$t('gestiune.cantitate')" v-model.number="item.cantitate"  @input="validateQty" class="form-control" />
                    <small v-if="item.stockQuantity !== undefined">
                      Stoc disponibil: <b>{{ item.stockQuantity }}</b>
                    </small>
                  </div>
                </div>

              </div>
            </div>

            <div class="modal-footer">
              <div class="button-group">
                <a class="btn btn-danger btn-icon mar-rt-10 delete" @click="closeModal">
                  {{$t('general.cancel2')}}
                </a>
                <button class="btn btn-icon btn-success mar-rt-10 save" @click="saveProduct">
                  {{$t('general.save')}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </vmodal>

      <ManagementSeriesAdd
        :locations="locations"
        :grouped-locations="groupedLocations"
        :vat-number="selectedLocation ? selectedLocation.inv_fiscal_code : ''"
        @getSeries="getSeries"
      />
    </div>
</template>

<script>
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import ManagementSeriesAdd from '../../Management/ManagementSeriesAdd.vue'
  import swal from 'sweetalert2'

  function getLocalDateTimeString () {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  export default {
    components: {
      PSwitch,
      ManagementSeriesAdd
    },
    data () {
      return {
        loading: false,
        selectedLocation: null,
        selectedLocationId: '',
        selectedToLocationId: '',
        locations: [],
        gestiuneOptions: [],
        avizOptions: [],
        nirOptions: [],
        bon_transferOptions: [],
        searchResults: [],
        selectedAviz: null,
        selectedNir: null,
        selectedSeries: null,
        currencyOptions: [
          { code: 'RON', name: 'Leu Românesc (RON)' },
          { code: 'EUR', name: 'Euro (EUR)' },
          { code: 'USD', name: 'Dolar American (USD)' }
        ],
        bonTransfer: {
          date: getLocalDateTimeString(),
          fromGestiune: null,
          toGestiune: null,
          serie: null,
          currency: 'RON',
          manager: '',
          receiver: '',
          internalNote: '',
          commandProject: ''
        },
        tableData: [],
        item: {
          productObject: null,
          um: '',
          cantitate: null
        },
        editIndex: null,
        isEdit: !!this.route.params.series && !!this.route.params.number,
        fetchTimeout: null,
        genereazaAvizNIR: false,
        avizGestiuneaPredatoare: '',
        dataAviz: '',
        nirGestiuneaPrimitoare: '',
        dataNIR: '',
        mesurementsUnits: []
      }
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      today () {
        const now = new Date()
        now.setSeconds(0, 0)
        return now.toISOString().slice(0, 16)
      },
      seriesOptionsWithAdd () {
        return [
          ...this.bon_transferOptions,
          { value: 'add', label: '➕ Adaugă serie' }
        ]
      },
      groupedLocations () {
        const groups = {}

        if (!this.locations || !this.locations.length) return []

        this.locations.forEach(location => {
          const vat = location.inv_fiscal_code || 'Fără cod fiscal'
          if (!groups[vat]) {
            groups[vat] = []
          }
          groups[vat].push(location)
        })

        const result = Object.entries(groups).map(([vat, locations]) => ({
          vat,
          locations
        }))

        return result
      },
      filteredGestiuni () {
        if (!this.selectedLocationId) return []
        const result = this.gestiuneOptions.filter(
          (g) => g.externalLocationId === this.selectedLocationId
        )
        return result
      },
      filteredToGestiuni () {
        if (!this.selectedToLocationId) return []
        return this.gestiuneOptions
        .filter(g => g.externalLocationId === this.selectedToLocationId)
        .map(g => {
          return {
            ...g,
            disabled:
              this.selectedToLocationId === this.selectedLocationId &&
              g.id === this.bonTransfer.fromGestiune
          }
        })
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')

      this.fetchGestiuni()
      this.fetchLocation()
    },
    watch: {
      selectedLocationId (id) {
        if (!this.isEdit) {
          this.bonTransfer.fromGestiune = null
          this.bonTransfer.toGestiune = null
          this.bonTransfer.serie = null
          this.selectedToLocationId = ''
          this.series = null
        }

        for (const group of this.groupedLocations) {
          const loc = group.locations.find(l => l.true_id === id)
          if (loc) {
            this.selectedLocation = loc
            if (!this.isEdit && loc.inv_fiscal_code) {
              this.getSeries(loc.inv_fiscal_code)
            }
            break
          }
        }
      },
      selectedToLocationId (id) {
        for (const group of this.groupedLocations) {
          const loc = group.locations.find(l => l.true_id === id)
          if (loc) {
            this.selectedToLocation = loc
            break
          }
        }
      },
      locations (newLocations) {
        if (newLocations && newLocations.length) {
          const s = this.route && this.route.params && this.route.params.series
          const inv = this.route && this.route.params && this.route.params.number
          if (s && inv) {
            this.fetchBonTransfer(s, inv)
          }
        }
      }
    },
    methods: {
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveBonTransfer() }
        })
      },
      getEmptyItem () {
        return {
          productObject: null,
          um: 'buc',
          cantitate: null,
          editIndex: null
        }
      },
      handleSerieChange (event) {
        const val = event.target.value
        if (val === 'add') {
          this.openSeriesModal()
          this.bonCasare.serie = null
        }
      },
      openSeriesModal () {
        this.$modal.show('addSeriesModal')
      },
      async fetchLocation () {
        const dataToSend = {
          company_id: this.companyID,
          token: this.$session.get('token')
        }

        this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
          if (!response || response.status !== true || !response.data || !response.data.locations) {
            swal({
              title: 'Eroare!',
              text: response.message || 'Eroare la preluarea locațiilor.',
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            })
            return
          }

          this.locations = response.data.locations
        })
      },
      async fetchBonTransfer (seriesParam, invoiceNumberParam) {
        try {
          const response = await fetch(
            `${process.env.API_BASE_URL_GESTIUNE}:4443/getDocument?tip=bon_transfer&series=${seriesParam}&number=${invoiceNumberParam}&externalCompanyId=${this.companyID}`
          )

          if (!response.ok) throw new Error('Failed to fetch bon de transfer')

          const data = await response.json()

          if (!data || !Array.isArray(data.documents) || !data.documents.length) {
            throw new Error('Bon de transfer inexistent')
          }

          const bon = data.documents[0]

          const extra = bon.extraFields || []
          const getField = (key) => {
            const field = extra.find(f => f.key === key)
            return field ? field.value : ''
          }

          const gestiuneFromObj = this.gestiuneOptions.find(g => g.name === bon.gestiune_from)
          const gestiuneToObj = this.gestiuneOptions.find(g => g.name === bon.gestiune_to)

          this.bonTransfer = {
            ...this.bonTransfer,
            fromGestiune: gestiuneFromObj ? gestiuneFromObj.id : bon.gestiune_from,
            toGestiune: gestiuneToObj ? gestiuneToObj.id : bon.gestiune_to,
            serie: bon.series,
            date: bon.date,
            documentNumber: bon.documentNumber,
            manager: getField('manager'),
            receiver: getField('receiver'),
            internalNote: getField('internalNote'),
            commandProject: getField('commandProject')
          }

          this.consumptionType = bon.type

          this.tableData = (bon.items || []).map(item => ({
            productName: item.name,
            cantitate: item.quantity,
            um: item.um,
            posId: item.posId
          }))

          if (bon.externalLocationId && this.locations && this.locations.length) {
            // Căutăm locația potrivită în groupedLocations
            let foundLocation = null
            for (const group of this.groupedLocations) {
              foundLocation = group.locations.find(loc =>
                (bon.externalLocationId && loc.true_id === bon.externalLocationId) ||
                (bon.vatNumber && loc.inv_fiscal_code === bon.vatNumber)
              )
              if (foundLocation) break
            }
            if (foundLocation) {
              this.selectedLocationId = foundLocation.true_id
            }
          }

          if (bon.externalLocationIdTo && this.locations && this.locations.length) {
            let foundToLocation = null
            for (const group of this.groupedLocations) {
              foundToLocation = group.locations.find(loc =>
                loc.true_id === bon.externalLocationIdTo ||
                loc.inv_fiscal_code === bon.vatNumberTo
              )
              if (foundToLocation) break
            }
            if (foundToLocation) {
              this.selectedToLocationId = foundToLocation.true_id
            }
          }
        } catch (error) {
          console.error('Error fetching bon de transfer:', error)
        }
      },
      async saveProduct () {
        if (!this.item.productObject || !this.item.cantitate) {
          swal({
            title: 'Eroare',
            text: 'Te rugăm să completezi toate câmpurile necesare!',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        const product = this.item.productObject

        const productId = product.product_id || this.item.productObject.posId

        const isValid = await this.checkValidatedAfter(this.bonTransfer.date, [productId])
        if (!isValid) return

        const newItem = {
          ...this.item,
          productName: product && product.productDetails && product.productDetails.name
            ? product.productDetails.name
            : product.label || product.name,
          posId: product && (product.product_id || product.posId)
        }

        console.log('New item added:', newItem)

        if (this.editIndex !== null && this.editIndex !== undefined) {
          this.$set(this.tableData, this.editIndex, newItem)
        } else {
          this.tableData.push(newItem)
        }

        this.resetModal()
        this.$modal.hide('addProductModal')
      },
      deleteRow (row) {
        const index = this.tableData.indexOf(row)

        if (index !== -1) {
          this.tableData.splice(index, 1)
        }
      },
      isDisabledToLocation (loc) {
        if (!this.selectedLocation) return false
        return loc.inv_fiscal_code !== this.selectedLocation.inv_fiscal_code
      },
      async checkValidatedAfter (date, products = null) {
        try {
          if (!date) return false

          if (!products) {
            if (!this.tableData || this.tableData.length === 0) {
              products = []
            } else {
              products = this.tableData.map(item => item.posId)
            }
          }

          const queryParams = new URLSearchParams({
            date: new Date(date).toISOString(),
            externalCompanyId: this.companyID,
            externalLocationId: this.selectedLocationId
          })

          const body = products.length > 0 ? { products } : null

          const response = await fetch(
            `${process.env.API_BASE_URL_GESTIUNE}:4443/inventar/validated-after-products?${queryParams.toString()}`,
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: body ? JSON.stringify(body) : null
            }
          )

          if (!response.ok) throw new Error(`Request failed: ${response.status}`)

          const data = await response.json()
          console.log('Response from validated-after:', data)

          if (data.exists) {
            await swal({
              icon: 'warning',
              title: 'Atenție!',
              text: 'Există deja un inventar validat după această dată pentru unul sau mai multe produse selectate.'
            })

            return false
          }

          return true
        } catch (err) {
          console.error(err)
          swal({
            icon: 'error',
            title: 'Eroare!',
            text: 'Nu s-a putut verifica inventarul.'
          })
          return false
        }
      },
      editRow (row) {
        const index = this.tableData.indexOf(row)
        if (index === -1) return

        this.editIndex = index


        const productObject = {
          posId: row.posId,
          productDetails: {
            name: row.productName,
            posId: row.posId,
            um: row.um
          },
          label: row.productName
        }

        const productOption = {
          label: row.productName,
          value: productObject
        }

        this.searchResults = [productOption]

        this.item = {
          productObject: productObject, // reținem doar valoarea, cum v-model o face
          um: row.um,
          cantitate: row.cantitate,
          posId: row.posId || null
        }

        this.$modal.show('addProductModal')
      },
      async fetchProducts (searchTerm) {
        clearTimeout(this.fetchTimeout)

        this.fetchTimeout = setTimeout(async () => {
          this.searchResults = []

          if (!searchTerm || searchTerm.length < 2) {
            return
          }

          if (!this.bonTransfer.fromGestiune) {
            swal({
              title: 'Atenție',
              text: 'Selectează gestiunea sursă înainte de a căuta un produs.',
              type: 'warning',
              confirmButtonText: 'OK'
            })
            return
          }

          if (!this.selectedLocation || !this.companyID) {
            return
          }

          let url = `${process.env.API_BASE_URL_GESTIUNE}:4443/products?externalCompanyId=${this.companyID}`

          url += `&gestiune=${this.bonTransfer.fromGestiune}`
          url += `&externalLocationId=${this.selectedLocation.true_id}`
          url += `&name=${encodeURIComponent(searchTerm)}`

          this.loading = true
          try {
            const response = await fetch(url)
            const data = await response.json()

            if (Array.isArray(data.products)) {
              this.searchResults = data.products.map(item => ({
                label: item.name,
                posId: item._id,
                value: item
              }))
              console.log(this.searchResults)
            } else {
              this.searchResults = []
              console.error('Invalid data format:', data)
            }
          } catch (error) {
            console.error('Error fetching stock:', error)
          } finally {
            this.loading = false
          }
        }, 300)
      },
      async fetchGestiuni () {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
          if (!response.ok) throw new Error('Failed to fetch gestiuni')

          const data = await response.json()
          console.log('Date primite de la server:', data.gestiuni)
          if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
            this.gestiuneOptions = data.gestiuni.map(gest => ({
              id: gest._id,
              name: `${gest.name} (${gest.cod_gestiune})`,
              externalLocationId: gest.externalLocationId || ''
            }))
          } else {
            swal({
              title: 'Error!',
              text: 'Nu s-a primit un array valid de la server.',
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        } catch (error) {
          swal({
            title: 'Error!',
            text: `Request failed: ${error.message}`,
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          console.error('Error fetching management data:', error)
        }
      },
      async getSeries (vatNumber) {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/getSeries`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              externalCompanyId: this.companyID,
              vatNumber: vatNumber,
              tip: 'bon_transfer'
            })
          })

          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`)
          }

          const data = await response.json()
          console.log('Serii primite:', data.series)

          if (Array.isArray(data.series)) {
            this.bon_transferOptions = data.series.map((serie) => ({
              value: serie._id,
              label: `${serie.series} - ${serie.currentNumber || 'N/A'}`,
              seriesName: serie.series,
              currentNumber: serie.currentNumber
            }))
          } else {
            console.error('Format invalid pentru series:', data)
          }
        } catch (error) {
          console.error('Error fetching series:', error)
        }
      },
      async saveBonTransfer () {
        if (!Array.isArray(this.bon_transferOptions)) {
          console.error('Bon Transfer options are not loaded or are not an array.')
          return
        }

        if (!this.tableData || this.tableData.length === 0) {
          swal({
            title: 'Eroare',
            text: 'Este necesar un produs minim de adăugat.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        const selectedSerie = this.bon_transferOptions.find(serie => serie.value === this.bonTransfer.serie)
        const serieName = selectedSerie ? selectedSerie.label : (this.bonTransfer.serie || '')

        // Spargem pe "-", apoi curățăm whitespace din prima parte
        const serieOnly = serieName.split('-')[0].trim()

        if (!Array.isArray(this.gestiuneOptions)) {
          console.error('Gestiune options are not loaded or are not an array.')
          return
        }

        const bonTransferData = {
          externalCompanyId: this.companyID,
          externalLocationId: this.selectedLocation.true_id,
          externalLocationIdTo: this.selectedToLocation.true_id,
          vatNumber: this.selectedLocation.inv_fiscal_code,
          series: serieOnly,
          tip: 'bon_transfer',
          gestiune_from: this.bonTransfer.fromGestiune,
          gestiune_to: this.bonTransfer.toGestiune,
          items: this.tableData.map(item => ({
            posId: item.posId,
            name: item.productName,
            quantity: item.cantitate,
            price: item.unitPrice,
            um: item.um
          })),
          currency: this.bonTransfer.currency,
          extraFields: Object.entries({
            manager: this.bonTransfer.manager,
            receiver: this.bonTransfer.receiver,
            commandProject: this.bonTransfer.commandProject,
            internalNote: this.bonTransfer.internalNote
          }).map(([key, value]) => ({ key, value }))
        }

        if (this.bonTransfer.date) {
          bonTransferData.date = this.bonTransfer.date
        }
        if (this.bonTransfer.documentNumber) {
          bonTransferData.documentNumber = this.bonTransfer.documentNumber
        }

        swal({
          title: 'Salvare în curs...',
          text: 'Se salvează Bonul de Trasnfer. Așteaptă te rog.',
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
          type: 'info'
        })

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/bon`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(bonTransferData)
          })

          const data = await response.json()

          swal.close()

          if (response.ok) {
            console.log('Bon transfer salvat cu succes!', data)

            swal({
              title: 'Succes',
              text: 'Bonul de transfer a fost salvat cu succes!',
              type: 'success',
              timer: 1500,
              showConfirmButton: false
            })

            this.$bus.$emit('refresh')
            this.$bus.$emit('close-modal')
          } else {
            console.error('Eroare la salvarea bonului de transfer', data)

            swal({
              title: 'Eroare',
              text: (data && data.error) ? data.error : 'A apărut o eroare la salvarea bonului de transfer.',
              type: 'error',
              confirmButtonText: 'OK'
            })
          }
        } catch (error) {
          swal.close()
          console.error('Eroare la trimiterea cererii', error)

          swal({
            title: 'Eroare',
            text: 'A apărut o problemă la trimiterea cererii.',
            type: 'error',
            timer: 1500,
            showConfirmButton: false
          })
        }
      },
      async fetchStockForProducts (productIDs, companyID, gestiune, locationID) {
        if (!productIDs || productIDs.length === 0) return []

        const params = new URLSearchParams()
        productIDs.forEach(id => params.append('product_ids', id))

        const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/stock?externalCompanyId=${companyID}` +
                    `&gestiune=${gestiune}` +
                    `&externalLocationId=${locationID}&${params.toString()}`

        swal({
          type: 'info',
          title: 'Loading Stock...',
          text: 'Please wait while we fetch stock data...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false
        })

        try {
          const response = await fetch(url)
          const data = await response.json()

          if (Array.isArray(data.stock)) {
            return data.stock
          } else {
            console.error('Invalid data format:', data)
            return []
          }
        } catch (err) {
          console.error('Error fetching stock:', err)
          return []
        } finally {
          swal.close()
        }
      },
      async handleProductSelect (selectedProduct) {
        const stockData = await this.fetchStockForProducts(
          [selectedProduct.posId || selectedProduct.value._id],
          this.companyID,
          this.bonTransfer.fromGestiune,
          this.selectedLocation.true_id
        )

        if (!stockData || stockData.length === 0) {
          swal({
            title: 'Stoc indisponibil',
            text: 'Produsul selectat nu mai are stoc!',
            icon: 'error',
            timer: 2500,
            buttons: false
          })
          this.productNameRecipe = null
          this.resetModal()
          return
        }

        if (stockData[0]) {
          const quantity = stockData[0].quantity

          if (quantity <= 0) {
            swal({
              title: 'Stoc indisponibil',
              text: 'Produsul selectat nu mai are stoc!',
              icon: 'error',
              timer: 2500,
              buttons: false
            })

            this.productNameRecipe = null
            this.resetModal()
            return
          }

          this.item.stockQuantity = quantity

          console.log('STOC', stockData[0])

          if (stockData[0].productDetails && stockData[0].productDetails.um) {
            this.item.um = stockData[0].productDetails.um
          }
        }
      },
      validateQty () {
        const max = this.item.stockQuantity

        // dacă încă nu s-a setat stocul
        if (max === undefined || max === null) return

        // dacă e gol
        if (!this.item.cantitate) return

        // convertim sigur în număr
        let val = Number(this.item.cantitate)

        if (val > max) val = max
        if (val < 0) val = 0

        this.item.cantitate = val
      },
      openAddProductModal () {
        this.$modal.show('addProductModal')
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      },
      closeModal () {
        this.resetModal()
        this.$modal.hide('addProductModal')
      },
      resetModal () {
        this.item = this.getEmptyItem()
        this.editIndex = null
      }
    }
  }
</script>
<style scoped>
.v-select input[type=search], .v-select input[type=search]:focus,
.v-select.searchable .dropdown-toggle {
    min-height: 46px;
    height: 46px;
}
.btn-primary {
  padding: 5px 50px;
}
.button-group {
    display: flex; /* Folosește flexbox pentru alinierea orizontală */
    justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.v-select-wrapper {
  position: relative;
}
.v-select-loader {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  border: 3px solid #e0e0e0;     /* mai deschis */
  border-top: 3px solid #007bff;  /* mai contrastant */
  border-radius: 50%;
  width: 24px;                    /* mai mare */
  height: 24px;
  animation: spin 0.8s linear infinite;
}
.small, small {
  font-size: 13px;
  top: 10px;
  color: green;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.arrow-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 2px solid #674BD2;
  border-radius: 6px;
  color: #674BD2;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;
}

.arrow-box:hover {
  background-color: #674BD2;
  color: #fff;
}

.custom-dropdown-menu {
  min-width: 140px;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Transfer/ManagementTransferForm.vue